/**
 * @fileoverview User profile settings route configuration
 * Handles the user profile management and settings interface
 */

// Library imports
import { createFileRoute } from "@tanstack/react-router";

// Page components
import UpdateProfilePage from "@/features/dashboard/pages/profile/pages/update-profile";
import { AppErrorBoundary } from "@/components/shared/app-error-boundary";

/**
 * Route configuration for the user profile settings page
 * Uses TanStack Router's file-based routing system
 */
export const Route = createFileRoute("/(app)/dashboard/settings/user-profile")({
  component: () => (
    <main
      role="main"
      aria-label="User profile settings"
      className="min-h-screen w-full"
    >
      <UpdateProfilePage />
    </main>
  ),
  errorComponent: AppErrorBoundary,
});
